import { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setSearch } from 'actions/NavV2Actions'
import { UNIT_VIEW_FORMAT } from 'utils/constants/constants'

const initialState = {
  activeUnitViewFormat: UNIT_VIEW_FORMAT.HTML,
  isLoading: true,
}

const UnitViewFormatContext = createContext(initialState)

export const UnitViewFormatProvider = ({ children }) => {
  const [activeUnitViewFormat, setActiveUnitViewFormat] = useState(
    initialState.activeUnitViewFormat
  )
  const dispatch = useDispatch()

  // TODO si se puede que este loading vaya por vista de libro y no genérico
  const [isLoading, setIsLoading] = useState(initialState.isLoading)

  const setUnitViewFormat = useCallback(
    (format) => {
      if (format === UNIT_VIEW_FORMAT.HTML || format === UNIT_VIEW_FORMAT.PAPER) {
        if (format === UNIT_VIEW_FORMAT.HTML) {
          dispatch(setSearch({ error: null, isLoading: false, query: '', results: null }))
        }
        setActiveUnitViewFormat(format)
        setIsLoading(true)
      }
    },
    [dispatch]
  )

  const handleLoadingComplete = useCallback(() => {
    setIsLoading(false)
  }, [])

  const contextValue = useMemo(
    () => ({
      handleLoadingComplete,
      isHtmlViewFormat: activeUnitViewFormat === UNIT_VIEW_FORMAT.HTML,
      isLoading,
      isPaperViewFormat: activeUnitViewFormat === UNIT_VIEW_FORMAT.PAPER,
      setUnitViewFormat,
    }),
    [activeUnitViewFormat, setUnitViewFormat, isLoading, handleLoadingComplete]
  )

  return (
    <UnitViewFormatContext.Provider value={contextValue}>{children}</UnitViewFormatContext.Provider>
  )
}

export const useUnitViewFormat = () => {
  const context = useContext(UnitViewFormatContext)
  if (!context) {
    throw new Error('useUnitViewFormat must be used within a UnitViewFormatProvider')
  }
  return context
}
